/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, DAKSH_SCREEN } from '../../global/Constants';
import { DakshSaleType, DakshModuleType } from '../../global/Enum';
import Select from 'react-select';
import DesktopFooter from '../common/DesktopFooter';
import Header from '../common/Header';
import Footer from '../common/Footer';
import './daksh.css';
import DakshHeader from './components/DakshHeader';
import Utilities from '../../global/Utilities';
import { v4 as uuidv4 } from 'uuid';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';

class AddCompetitorSale extends Component {

    constructor(props) {
        super(props);
        this.isSelectAll = false;
        this.state = {
            selectedCrop: null,
            selectedHybrid: null,
            weightUnitId: 0,
            quantity: "",
            moduleType: 2,
            data: [],
            competitors: [],
            selectedRow: null,
            isEdit: false,
            crops: [],
            hybrids: [],
            weightUnits: [
                { weight_unit_id: 2, name: "Kg" },
                { weight_unit_id: 3, name: "Gram" },
                { weight_unit_id: 4, name: "Packet" }
            ]
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const data = this.props.location.state?.data;
            const moduleType = this.props.location.state?.moduleType;
            if (data) {
                Utilities.LogPrint("Data", this.props.location.state);
                this.setState({
                    moduleType: moduleType ? moduleType : 2,
                    data: data,
                    competitors: data?.competitors
                });
            }
            this.getCrops();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getCrops = () => {
        //const userCrops = DataProvider.getInstance().getUserCrops();
        const crops = DataProvider.getInstance().getCrops();
        if (crops.length > 0) {
            const newArrayOfObj = crops.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }));
            this.setState({ crops: newArrayOfObj });
        }
    }

    getCompetitorHybrids = (cropId) => {
        const { competitors } = this.state;
        //const competitorHybrids = DataProvider.getInstance().getCompetitorHybrids();

        this.getHybridData(cropId).then(hybrids => {
            Utilities.LogPrint("Hybrids Final:", hybrids);
            if (hybrids.length > 0) {
                if (competitors.length > 0) {
                    const hybridData = hybrids.filter(hybrid => !competitors.some(item => hybrid.competitor_hybrid_id === item.hybrid_id));
                    Utilities.LogPrint("hybridData final", hybridData);

                    const newArrayOfObj = hybridData.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
                    this.setState({ hybrids: newArrayOfObj });

                } else {
                    const newArrayOfObj = hybrids.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
                    this.setState({ hybrids: newArrayOfObj });
                }

            }
        });

        // if (competitorHybrids.length > 0) {
        //     const hybrids = competitorHybrids.filter(item => {
        //         return (item.crop_id === cropId && item.is_active === 1 && item.state_id === retailer?.state_id);
        //     });
        //     Utilities.LogPrint("Crop Wise Hybrid", hybrids);

        //     if (competitors.length > 0) {

        //         const hybridData = hybrids.filter(hybrid => !competitors.some(item => hybrid.competitor_hybrid_id === item.hybrid_id));
        //         Utilities.LogPrint("hybridData final", hybridData);

        //         if (hybridData.length > 0) {
        //             const newArrayOfObj = hybridData.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ hybrids: newArrayOfObj });
        //         }

        //     } else {
        //         const newArrayOfObj = hybrids.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
        //         this.setState({ hybrids: newArrayOfObj });
        //     }

        //     //const newArrayOfObj = hybrids.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
        //     //this.setState({ hybrids: newArrayOfObj });
        // }


    }

    getHybridData = (cropId) => {

        return new Promise(function (resolve) {

            //TODO : BASED ON DAKSH COMPETITOR HYBRID
            const hybrids = DataProvider.getInstance().getDakshCompetitorHybrids();
            const retailer = Utilities.getRetailer();
            Utilities.LogPrint("Retailer", retailer);

            const hybridsData = hybrids.filter(hybrid => {
                return (hybrid.crop_id === cropId && hybrid.state_id === retailer?.state_id)
            });
            Utilities.LogPrint("Hybrid 1:", hybridsData);
            resolve(hybridsData);
        });

        // return new Promise(function (resolve) {

        //     //TODO : BASED ON HYBRID
        //     const hybrids = DataProvider.getInstance().getHybrids();
        //     const competitorHybrids = DataProvider.getInstance().getCompetitorHybrids();
        //     const retailer = Utilities.getRetailer();
        //     Utilities.LogPrint("Retailer", retailer);

        //     const hybridsData = hybrids.filter(hybrid => {
        //         return (hybrid.crop_id === cropId && hybrid.is_active === 1)
        //     });
        //     Utilities.LogPrint("Hybrid 1:", hybridsData);

        //     const competitorHybridsData = competitorHybrids.filter(item => {
        //         return hybridsData.find(hybrid => {
        //             return hybrid.hybrid_id === item.hybrid_id &&
        //                 item.is_active === 1 &&
        //                 item.state_id === retailer?.state_id
        //         });
        //     });
        //     Utilities.LogPrint("Hybrid 2:", competitorHybridsData);

        //     resolve(competitorHybridsData);
        // });

    }


    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelectAllCheckbox = (e) => {
        Utilities.LogPrint("checkAll", e.target.checked);
        this.isSelectAll = e.target.checked;
        let array = this.state.competitors;
        array.forEach(item => {
            item.isSelected = e.target.checked;

        });
        this.setState({ competitors: array });
    }

    handleCheckbox = (item) => {
        Utilities.LogPrint("Event", item);

        let array = this.state.competitors;
        array.forEach(obj => {
            if (obj.id === item.id) {
                obj.isSelected = true;
            } else {
                obj.isSelected = false;
            }
        });

        this.isSelectAll = false;
        this.setState({ competitors: array, selectedRow: item });

        //this.setState({ selectedRow: item })
        // this.setState({
        //     isSelected: !this.state.isSelected
        // }, () => {
        //     if (!this.state.isSelected) {
        //         this.setState({ selectedRow: item })
        //         // this.setState({
        //         //     crop: item.crop,
        //         //     hybrid: item.hybrid,
        //         //     quantity: item.quantity
        //         // })
        //     } else {
        //         this.setState({ selectedRow: null })
        //         //this.resetInputField();
        //     }
        // });

    }

    resetInputField = () => {
        this.setState({
            selectedCrop: null,
            selectedHybrid: null,
            quantity: "",
            isSelected: false,
            weightUnitId: 0
        })
    }

    handleEdit = () => {
        const { selectedRow } = this.state;

        Utilities.LogPrint("Edit Click", selectedRow);
        if (selectedRow !== null) {
            this.setState({
                selectedCrop: { value: selectedRow.crop_id, label: selectedRow.crop_name },
                selectedHybrid: { value: selectedRow.hybrid_id, label: selectedRow.hybrid_name },
                quantity: selectedRow.quantity,
                weightUnitId: selectedRow.weight_unit_id,
                isEdit: true
            })
        }
    }

    handleDelete = () => {
        const { competitors, selectedRow } = this.state;
        if (!this.isSelectAll) {
            let array = competitors;
            var index = array.indexOf(selectedRow);
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ competitors: array });
            }
        }
        else {
            this.setState({ competitors: [] });
        }
    }

    getUnitById = (unitId) => {
        const { weightUnits } = this.state;
        if (weightUnits.length > 0) {
            let unit = weightUnits.find(item => item.weight_unit_id === unitId);
            Utilities.LogPrint("UNIT", unit);
            if (unit !== null) {
                return unit?.name;
            }
        }
    }

    handleAddButton = () => {
        const { selectedCrop, selectedHybrid, quantity, competitors, weightUnitId } = this.state;
        let tempArray = competitors;
        let obj = {
            id: uuidv4(),
            crop_id: selectedCrop?.value,
            crop_name: selectedCrop?.label,
            hybrid_id: selectedHybrid?.value,
            hybrid_name: selectedHybrid?.label,
            quantity: quantity,
            weight_unit_id: weightUnitId,
            weight_unit_name: this.getUnitById(weightUnitId),
            isSelected: false
        }
        tempArray.push(obj);
        Utilities.LogPrint("Save", tempArray);

        this.setState({
            competitors: tempArray
        }, () => {
            this.resetInputField();
            //this.updateArray();
        })
    }

    handleEditButton = () => {
        const { selectedRow, selectedCrop, selectedHybrid, quantity, weightUnitId } = this.state;

        let array = this.state.competitors;
        //Utilities.LogPrint("Edit Array", array);
        //Utilities.LogPrint("selectedRow", selectedRow);
        array.forEach(obj => {
            if (obj.id === selectedRow.id) {
                obj.crop_id = selectedCrop.value;
                obj.crop_name = selectedCrop.label
                obj.hybrid_id = selectedHybrid.value;
                obj.hybrid_name = selectedHybrid.label;
                obj.quantity = quantity;
                obj.weight_unit_id = weightUnitId;
                obj.weight_unit_name = this.getUnitById(weightUnitId);
            }
        })
        this.setState({
            competitors: array,
            isEdit: false,
        }, () => {
            this.resetInputField();
        });
    }

    handleSaveButton = () => {
        const { competitors, data, moduleType } = this.state;
        //this.props.history.replace(ALL_ROUTES.SUBMIT_SALE_ROUTE);

        let totalQty = 0;
        for (const obj of competitors) {
            totalQty += parseInt(obj.quantity);
        }
        Utilities.LogPrint("Total", totalQty);

        let dataObj = data;
        dataObj.total = totalQty + dataObj.total_seedworks;
        dataObj.total_competitor = totalQty;
        dataObj.competitors = competitors;

        Utilities.LogPrint("DataObj", dataObj);

        if (moduleType === DakshModuleType.PLAN) {
            this.props.history.replace({
                pathname: ALL_ROUTES.PLAN_DETAILS_ROUTE,
                state: { saleType: DakshSaleType.NONE, planData: dataObj, isSubmitVisible: true }
            });
        } else {
            this.props.history.replace({
                pathname: ALL_ROUTES.SALE_DETAILS_ROUTE,
                state: { saleType: DakshSaleType.NONE, saleData: dataObj, isSubmitVisible: true }
            });
        }
    }

    handleCancelButton = () => {
        this.props.history.goBack();
    }

    handleCropChange = (selectedCrop) => {
        Utilities.LogPrint("Selected Crop", selectedCrop);

        let unitId = 0;
        if (selectedCrop.value === 1) {
            unitId = 4;
        } else if (selectedCrop.value === 2) {
            unitId = 2;
        } else {
            unitId = 3;
        }

        this.setState({
            selectedCrop,
            //hybrids: [],
            selectedHybrid: null,
            weightUnitId: unitId
        }, () => {
            this.getCompetitorHybrids(selectedCrop.value);
        });
    }

    handleHybridChange = (selectedHybrid) => {
        Utilities.LogPrint("Selected Hybrid", selectedHybrid);
        this.setState({ selectedHybrid });
    }

    updateArray = () => {
        const { hybrids, competitors } = this.state;

        Utilities.LogPrint("hybridData: 1", hybrids);
        Utilities.LogPrint("hybridData: 2", competitors);

        if (competitors.length > 0) {
            const hybridData = hybrids.filter(hybrid => {
                return competitors.find(item => { return item?.hybrid_id !== hybrid.value });
            });
            Utilities.LogPrint("hybridData: final", hybridData);
            this.setState({ hybrids: hybridData })
        }
    }

    handleRadioChange = (e) => {
        Utilities.LogPrint("Unit", e.target.value);
        this.setState({
            weightUnitId: parseInt(e.target.value)
        })
    }

    isFormValid() {
        const { selectedCrop, selectedHybrid, quantity, weightUnitId } = this.state;
        return selectedCrop === null || selectedHybrid === null || quantity === "" || weightUnitId === 0;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { crops, hybrids, weightUnits, selectedCrop, selectedHybrid, quantity, competitors, isEdit, weightUnitId } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer />

                <div className="container pt-35 daksh">
                    <DakshHeader />

                    <div className="row">
                        <div className="col-12">

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label className="font-weight-medium">Crop</label>
                                        {/* <input type="text" className="form-control" name="crop" placeholder="Enter Crop" onChange={this.changeHandler} value={crop} /> */}
                                        <Select className="mb-3"
                                            value={selectedCrop}
                                            onChange={this.handleCropChange}
                                            options={crops}
                                            placeholder="Select the Crop"
                                            isClearable={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label className="font-weight-medium">Hybrid</label>
                                        {/* <input type="text" className="form-control" name="hybrid" placeholder="Enter Hybrid" onChange={this.changeHandler} value={hybrid} /> */}
                                        <Select className="mb-3"
                                            value={selectedHybrid}
                                            onChange={this.handleHybridChange}
                                            options={hybrids}
                                            placeholder="Select the Hybrid"
                                            isClearable={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label className="font-weight-medium">Quantity</label>
                                        <input type="number" className="form-control" name="quantity" placeholder="Enter Quantity" onChange={this.changeHandler} value={quantity} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">

                                        {weightUnits?.map((item, i) => (
                                            <label className="radio-container" key={i}>{item.name}
                                                <input type="radio" name="radio"
                                                    value={item.weight_unit_id}
                                                    checked={item.weight_unit_id === weightUnitId}
                                                    disabled={true}
                                                    onChange={this.handleRadioChange} />
                                                <span className="checkmark"></span>
                                            </label>
                                        ))}


                                        {/* <label className="radio-container">Kg
                                            <input type="radio" name="radio" value="Kg" onChange={this.handleRadioChange} />
                                            <span className="checkmark"></span>
                                        </label>
                                        <label className="radio-container">Gram
                                            <input type="radio" name="radio" value="Gram" onChange={this.handleRadioChange} />
                                            <span className="checkmark"></span>
                                        </label>
                                        <label className="radio-container">Packet
                                            <input type="radio" name="radio" value="Packet" onChange={this.handleRadioChange} />
                                            <span className="checkmark"></span>
                                        </label> */}
                                    </div>
                                </div>
                            </div>

                            {/* <button className="btn btn-primary w-182 mb-4" onClick={this.handleSave}>
                                {COMMON.ADD}
                            </button> */}

                            {!isEdit ?
                                <button
                                    className="btn btn-primary w-182 mb-4"
                                    disabled={this.isFormValid()}
                                    onClick={this.handleAddButton}>
                                    {COMMON.ADD}
                                </button> :
                                <button
                                    className="btn btn-primary w-182 mb-4"
                                    disabled={this.isFormValid()}
                                    onClick={this.handleEditButton}>
                                    {COMMON.EDIT}
                                </button>
                            }
                        </div>

                        {/* Competitor Sale */}
                        {competitors.length > 0 ?
                            <div className="col-12 p-0">
                                <div className="col-12 sale-table">
                                    <h5 className="font mt-2 mt-md-4 d-flex">
                                        {DAKSH_SCREEN.COMPETITOR_SALE}

                                        <a className="ml-auto mr-1">
                                            <i className="customic ic-daksh-edit" onClick={this.handleEdit}></i>
                                        </a>
                                        <a className="mr-1">
                                            <i className="customic ic-daksh-delete" onClick={this.handleDelete}>
                                            </i>
                                        </a>
                                        {/*<a href=""><i class="customic ic-daksh-add"></i></a>*/}
                                    </h5>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="no-border">
                                                        <label className="checkbox-container">
                                                            <input type="checkbox" onChange={this.handleSelectAllCheckbox} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </th>
                                                    <th width="30%">Crop</th>
                                                    <th width="30%">Hybrid</th>
                                                    <th width="20%">Quantity</th>
                                                    <th width="20%">Units</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {competitors.map((item, i) => (
                                                    <tr className="cursor-pointer" key={i}>
                                                        <td className="no-border">
                                                            <label className="checkbox-container">
                                                                <input type="checkbox"
                                                                    value={i}
                                                                    checked={item.isSelected}
                                                                    onChange={() => this.handleCheckbox(item)} />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>{item.crop_name}</td>
                                                        <td>{item.hybrid_name}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item.weight_unit_name}</td>
                                                    </tr>
                                                ))}

                                                {/* <tr className="cursor-pointer">
                                                    <td className="no-border">
                                                        <label className="checkbox-container">
                                                            <input type="checkbox" />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </td>
                                                    <td>Cotton</td>
                                                    <td>Us51</td>
                                                    <td><b>50</b></td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-12 mt-4 mb-4 btn-group-w">
                                    <button className="btn btn-primary w-182" onClick={this.handleSaveButton}>{COMMON.SAVE}</button>
                                    <button className="btn btn-secondary ml-3 w-182" onClick={this.handleCancelButton}>{COMMON.CANCEL}</button>
                                </div>
                            </div> : null
                        }
                    </div>

                </div>
                <DesktopFooter />
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>
        )
    }
}

export default withRouter(AddCompetitorSale);